import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";

import Breadcrumb from "../../components/Breadcrumb";
import AllVehicleLayer from "../../components/vehicles/AllVehicleLayer";




const AllVehiclePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="All Vehicles" />

        {/* TableDataLayer */}
        <AllVehicleLayer />
        {/* <AlertLayer/> */}
    

      </MasterLayout>

    </>
  );
};

export default AllVehiclePage; 
